module.exports = __webpack_public_path__ + "img/image7.2d0d4716.jpeg";